var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"c-base-summary"},[(_vm.isHeader)?_c('div',{staticClass:"c-base-summary__header"},[_vm._t("header")],2):_vm._e(),_vm._t("default"),(_vm.isFooter)?_c('div',{staticClass:"c-base-summary__footer"},[_vm._t("footer")],2):_vm._e()],2)
}
var staticRenderFns = []

export { render, staticRenderFns }